// custom-product-reviews.js
//
// Rating, Anzahl und die ersten 3 Reviews werden server-seitig in der Liquid-
// Section aus dem Judge.me-Metafeld (judgeme.review_widget_data) gerendert.
// Dieses Skript steuert nur noch das Popup, das beim Klick auf
// "ALLE X BEWERTUNGEN ANSEHEN" das offizielle Judge.me Review-Widget öffnet
// (mit voller Pagination durch alle Bewertungen, nicht nur die ersten paar).

function openAllReviewsModal() {
    const modal = document.getElementById('kruut-reviews-modal');
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleReviewsModalKeydown);
}

function closeAllReviewsModal() {
    const modal = document.getElementById('kruut-reviews-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleReviewsModalKeydown);
}

function handleReviewsModalKeydown(e) {
    if (e.key === 'Escape') closeAllReviewsModal();
}

document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById('kruut-reviews-modal');
    if (!overlay) return;

    overlay.addEventListener('click', (e) => {
        // Klick auf den dunklen Hintergrund schließt das Popup
        if (e.target === overlay) {
            closeAllReviewsModal();
            return;
        }

        // Klick auf "Bewertung schreiben": unser eigenes Modal aus dem Weg
        // räumen, statt mit Judge.mes eigenem Formular-Popup um die
        // Stapel-Reihenfolge (z-index) zu konkurrieren. Das Formular lebt
        // unabhängig von unserem Modal weiter und bekommt so die Bühne für
        // sich allein, ohne dass wir raten müssen, wie Judge.me es intern
        // baut.
        const label = (e.target.textContent || '').trim().toLowerCase();
        const isWriteReviewTrigger =
            e.target.closest('[class*="write-rev"]') || label.includes('bewertung schreiben');
        if (isWriteReviewTrigger) {
            closeAllReviewsModal();
        }
    });
});

// Judge.me rendert manche Texte im Review-Widget fest in Englisch bzw. im
// US-Format, unabhängig von der Shop-Sprache. Das ist reiner Textinhalt,
// den CSS nicht ändern kann - deshalb hier eine kleine, rein textliche
// Nachbearbeitung. Alle drei Fixes sind idempotent (mehrfaches Ausführen
// ändert nichts kaputt), deshalb einfach bei jeder Widget-Änderung erneut
// laufen lassen, statt genau zu tracken, wann Judge.me was neu rendert.

const JDGM_COUNTRY_NAMES_DE = {
    'Germany': 'Deutschland',
    'Austria': 'Österreich',
    'Switzerland': 'Schweiz',
    'Italy': 'Italien',
    'France': 'Frankreich',
    'Netherlands': 'Niederlande',
    'Belgium': 'Belgien',
    'Luxembourg': 'Luxemburg',
    'United Kingdom': 'Vereinigtes Königreich',
    'United States': 'USA',
    'Spain': 'Spanien',
    'Poland': 'Polen',
    'Denmark': 'Dänemark',
    'Sweden': 'Schweden',
    'Norway': 'Norwegen',
    'Finland': 'Finnland',
    'Czechia': 'Tschechien',
    'Czech Republic': 'Tschechien',
    'Portugal': 'Portugal',
};

const JDGM_US_DATE_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$/;

function localizeJudgemeWidgetText() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;

    // 1) "Kundenbewertungen" -> "Bewertungen"
    widget.querySelectorAll('.jm-review-widget-minimal-header__title').forEach((el) => {
        if (el.textContent.trim() === 'Kundenbewertungen') {
            el.textContent = 'Bewertungen';
        }
    });

    // 2) Länder-Namen ins Deutsche übersetzen
    widget.querySelectorAll('.jm-location').forEach((el) => {
        const text = el.textContent.trim();
        if (JDGM_COUNTRY_NAMES_DE[text]) {
            el.textContent = JDGM_COUNTRY_NAMES_DE[text];
        }
    });

    // 3) US-Datumsformat (MM/DD/YYYY) -> deutsches Format (DD.MM.YYYY)
    // Kein eigener Klassenname für das Datum vorhanden, daher gezielt nur
    // innerhalb des Review-Widgets nach dem Zahlenmuster suchen.
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
        const match = node.nodeValue.trim().match(JDGM_US_DATE_REGEX);
        if (match) {
            const [, mm, dd, yyyy] = match;
            node.nodeValue = `${dd}.${mm}.${yyyy}`;
        }
    }
}

if (window.MutationObserver) {
    localizeJudgemeWidgetText();
    const jdgmTextObserver = new MutationObserver(() => {
        localizeJudgemeWidgetText();
    });
    jdgmTextObserver.observe(document.body, { childList: true, subtree: true });
}
